import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useAcrissGroups, useAcrissGroupsValidator } from "Pages/OneWay/AcrissGroups/@hooks"


export default function AcrissGroupDrawerSubmit() {
	const { isLoading, handleSubmitFormData } = useAcrissGroups()
	const { isValid } = useAcrissGroupsValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitFormData}
	>
		Save
	</ButtonLoadingSeeker>
}
